import type {
  FulfillmentLine,
  FulfillmentLineBulkActionResult,
  FulfillmentLineResult,
  FulfillmentRunDetail,
  FulfillmentRunResult,
  Paginated,
  PennylaneRunDetail,
  PennylaneRunResult,
  RunListItem,
  RunListQuery,
} from '@flux/shared';
import { apiFetch, downloadFromApi } from '@/lib/api/client.js';

/**
 * Couche réseau de l'onglet **Runs** du Journal (`02` §11) : la liste
 * unifiée des runs (Suivi Martelet + Pennylane), leurs détails, les lignes en
 * erreur du Suivi Martelet, et les deux boutons « Lancer ».
 */

export function fetchRuns(query: RunListQuery): Promise<Paginated<RunListItem>> {
  return apiFetch<Paginated<RunListItem>>('/api/runs', { query });
}

export function fetchFulfillmentRunDetail(id: string): Promise<FulfillmentRunDetail> {
  return apiFetch<FulfillmentRunDetail>(`/api/fulfillment/runs/${id}`);
}

export function fetchPennylaneRunDetail(id: string): Promise<PennylaneRunDetail> {
  return apiFetch<PennylaneRunDetail>(`/api/pennylane/runs/${id}`);
}

export function downloadFulfillmentRawFile(id: string): void {
  downloadFromApi(`/api/fulfillment/files/${id}/raw`);
}

/** « Lancer le suivi Martelet » (`02` §11). `simulation` pour un essai à blanc. */
export function runFulfillmentNow(simulation: boolean): Promise<FulfillmentRunResult> {
  return apiFetch<FulfillmentRunResult>('/api/fulfillment/run', { method: 'POST', body: { simulation } });
}

/** « Lancer Pennylane » (`02` §11). */
export function runPennylaneNow(simulation: boolean): Promise<PennylaneRunResult> {
  return apiFetch<PennylaneRunResult>('/api/pennylane/run', { method: 'POST', body: { simulation } });
}

export interface ErrorLinesParams {
  page: number;
  pageSize: number;
  sortDir: 'asc' | 'desc';
  sortBy?: string;
  store?: string;
  search?: string;
}

export function fetchFulfillmentErrorLines(params: ErrorLinesParams): Promise<Paginated<FulfillmentLine>> {
  return apiFetch<Paginated<FulfillmentLine>>('/api/fulfillment/lines', {
    query: {
      page: params.page,
      pageSize: params.pageSize,
      sortDir: params.sortDir,
      result: ['error'] satisfies FulfillmentLineResult[],
      ...(params.sortBy ? { sortBy: params.sortBy } : {}),
      ...(params.store ? { store: params.store } : {}),
      ...(params.search ? { search: params.search } : {}),
    },
  });
}

export function retryFulfillmentLines(lineIds: string[]): Promise<FulfillmentLineBulkActionResult> {
  return apiFetch<FulfillmentLineBulkActionResult>('/api/fulfillment/lines/retry', {
    method: 'POST',
    body: { lineIds },
  });
}

export function ignoreFulfillmentLines(
  lineIds: string[],
  reason: string,
): Promise<FulfillmentLineBulkActionResult> {
  return apiFetch<FulfillmentLineBulkActionResult>('/api/fulfillment/lines/ignore', {
    method: 'POST',
    body: { lineIds, reason },
  });
}
